import './breakpoints-config';
import './responsive-image.config';
import './route-query.config';
import '../content';

import { App } from 'vue';
import formComponentRegistration from '@/shared/form';
import projectComponentRegistration from '@/shared/config/project-component-registrations';

export default function B2BConfig(app: App<Element>) {
    formComponentRegistration(app);
    projectComponentRegistration(app);
}
